import { LOCATION_POLL_INTERVAL_MS } from "./numbers"

// Google Maps mapTypeId values, labelled for the Settings page.
export const MAP_STYLES = [
    { value: "roadmap", label: "Standard", icon: "bi-map" },
    { value: "satellite", label: "Satellite", icon: "bi-globe-americas" },
    { value: "terrain", label: "Terrain", icon: "bi-triangle" },
]
export const DEFAULT_MAP_STYLE = "roadmap"

// Kept at or above the 15 minute server-side stale window, so a member's
// location never goes stale just because of this setting.
export const LOCATION_REFRESH_OPTIONS_MINUTES = [15, 30, 60]
export const DEFAULT_LOCATION_REFRESH_MINUTES = LOCATION_POLL_INTERVAL_MS / 60000

export const LOCATION_PERMISSION_OPTIONS = [
    { value: "allow", label: "Allow" },
    { value: "ask", label: "Ask me" },
    { value: "deny", label: "Don't allow" },
]

export const PREFERENCES_CHANGE_EVENT = "preferencesChange"
